<template>
    <div class="header" v-on:click="headerClick()">
        <img class="bg-grid" src="../assets/headercota.svg" alt="Cota.80.86 - Arqueologia"/>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        methods: {
            headerClick() {
                this.$router.push('/').catch(() => {});
            }
        }
    }
</script>


<style scoped>
    body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, p, pre, code, blockquote {
        margin: 0;
        padding: 0;
        border-width: 0;
    }

    td, th {
        border-style: solid;
        border-width: 1px;
    }

    table {
        border-collapse: collapse;
    }

    li {
        display: block;
    }

    body {
        font-size: 12px;
        -epub-hyphens: auto;
    }

    img.bg-grid {
        width: 100%;
        height: 100%;
        max-height: 8em;
        object-fit: cover;
        object-position: top;

    }

    div.header {
        margin: 0px auto 0px 0px;
        text-align: center;
        height: 8em;
    }

</style>
